module.exports = __webpack_public_path__ + "static/scale-model-of-currier-museum-of-art-in-manchester-new-hampshire-98608f3e289d6a90a1001e49e260ea10.png";